import {
  MRT_GlobalFilterTextField as EquipmentListGlobalFilterTextField,
  MRT_ShowHideColumnsButton as EquipmentListShowHideColumnsButton,
  MRT_TableInstance,
  MRT_ToggleFiltersButton as EquipmentListToggleFiltersButton
} from "material-react-table";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { Button, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { AddBox, Delete, FileDownload } from "@mui/icons-material";
import ExcelUploadModal from "../../../ExcelUpload/excel-upload.modal";
import { bulkEquipmentExcelUpload } from "../../../../utils/axios-requests";
import { EquipmentRow } from "../typings/equipment-row.types";

type Props = {
  table: MRT_TableInstance<EquipmentRow>;
  exportPopOpen: boolean;
  disabledDeleteButton: boolean;
  setAnchorEl: (e: HTMLElement | null) => void;
  onReload: () => Promise<void>;
  onDelete: () => void;
  anchorEl: HTMLElement | null;
};
export const FilterableEquipmentListTopToolbar = ({
  table,
  exportPopOpen,
  disabledDeleteButton,
  setAnchorEl,
  onReload,
  onDelete,
  anchorEl
}: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Grid2
      container
      sx={{ display: "flex", p: 2, justifyContent: "space-between", alignItems: "center" }}
    >
      <Typography variant={"h5"} sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
        {t("Equipment")}
      </Typography>

      <Grid2 sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }} gap={1}>
        {/* import MRT sub-components */}
        {/* to avoid duplication, changed the name */}
        <EquipmentListGlobalFilterTextField table={table} />
        <EquipmentListToggleFiltersButton table={table} />
        <EquipmentListShowHideColumnsButton table={table} />

        {/* delete selected equipment button */}
        <Tooltip
          title={<Typography>{t("Delete selection")}</Typography>}
          aria-label={"Delete selection"}
        >
          <span>
            <IconButton
              color="error"
              data-testid="handle-remove-equipment-btn"
              disabled={disabledDeleteButton}
              onClick={onDelete}
              size="large"
            >
              <Delete />
            </IconButton>
          </span>
        </Tooltip>

        {/* export as csv/pdf button */}
        <Tooltip title={<Typography>{t("Export")}</Typography>} aria-label={"Export"}>
          <IconButton
            data-testid="Export-equipment-btn"
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              setAnchorEl(anchorEl ? null : event.currentTarget);
            }}
            color={exportPopOpen ? "primary" : "default"}
            size="large"
          >
            <FileDownload />
          </IconButton>
        </Tooltip>

        <ExcelUploadModal
          onFinishUpload={() => {
            enqueueSnackbar(t("Successfully uploaded equipments"), { variant: "success" });
          }}
          uploadCall={bulkEquipmentExcelUpload}
          triggerCall={onReload}
        />

        {/* add new equipment button */}
        <Button
          data-testid="Add-new-equipment-btn"
          onClick={() => table.setCreatingRow(true)}
          sx={{ height: "fit-content", alignSelf: "center", p: "6px 12px" }}
        >
          <AddBox sx={{ mr: 1 }} />
          {t("Add Equipment")}
        </Button>
      </Grid2>
    </Grid2>
  );
};
